<script setup>

    import { storeToRefs } from 'pinia';

    import { useWindowStore } from '@/stores/window';
    const { scrollY, innerHeight } = storeToRefs(useWindowStore());

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }

    const offscreen = ref(true);
    const isFixed = ref(false);


    const topbox = ref();

    watch(scrollY, (newScrollY) => {
        // Get the back-to-top element position
        const backToTopElement = topbox.value;
        const windowHeight = innerHeight.value;
        const backToTopPosition = backToTopElement?.getBoundingClientRect().top - windowHeight;
        // Set fixed class based on scroll position
        isFixed.value = (newScrollY >= windowHeight && backToTopPosition > 0);
        offscreen.value = (newScrollY <= windowHeight);
    });

</script>
<template>
    <div class="back-to-top relative z-[50]" :class=" { 'is-fixed': isFixed, 'offscreen': offscreen }" ref="topbox">
        <button @click="scrollToTop" aria-label="Click to scroll to the top of the page"
            class="absolute z-[1000] cursor-pointer left-[1.375rem] bottom-[1.375rem]
                rounded-[50px] h-[36px] px-[20px]
                flex items-center justify-center gap-[10px]
                uppercase bg-white text-[var(--magenta)]
                font-hubspot-sans text-[12px] font-medium leading-none tracking-[0.84px]
                lg:bottom-[2.375rem] lg:left-[2.375rem]">
            <span>Back to top</span>
            <svg width="7" height="7" viewBox="0 0 8.5 8.5" fill="none" aria-hidden="true">
                <path d="M4.25 7.75V0.75M0.75 4.05556L4.25 0.75L7.75 4.05556" stroke="var(--dark-pink)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>
</template>

<style>
/* State-dependent overrides */
.back-to-top.is-fixed button {
    position: fixed;
    opacity: 1;
    transform: translateY(0%);
    z-index: 9999;
    box-shadow: 0 4px 16px rgba(70, 6, 43, 0.15);
    transition: opacity 250ms ease-in-out;
}

.back-to-top.offscreen button {
    position: fixed;
    opacity: 0;
    transition: 250ms ease-in-out;
    transform: translateY(100%);
}

@media (hover: hover) {
    .back-to-top button:hover {
        background-color: var(--magenta);
        color: white;
    }
}
</style>
